<template>
  <div class="mr-visit page">
    <RegistCompleted v-if="this.completed"/>
    <div v-else class="container">
      <v-form ref="form">
        <VisitRegistForm ref="refVisitForm" :visitData="visitData" />

        <div class="bottom-btn">
          <v-btn
            class="btn-text-white"
            color="mainColorDark"
            x-large
            depressed
            block
            @click="clickSave"
          >
            MR 방문 접수하기
          </v-btn>
        </div>
      </v-form>
    </div>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VisitRegistForm from "./comp/VisitRegistForm.vue";
import RegistCompleted from "./comp/RegistCompleted.vue";
import Footer from "../commonComp/Footer.vue";
const modelService = require("@/utils/dataModel.js");
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    VisitRegistForm,
    RegistCompleted,
    ConfirmDialog,
    Footer
  },
  data() {
    return {
      pwShow: false,
      visitData: modelService.visitData(),
      completed: false
    };
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  mounted() {
    const $h = this.$helper;
    this.getMeInfo().then(() => {
      this.userData = this.meInfo;
      this.visitData.hospital = this.userData.hospital;
      this.visitData.hospitalAddr = this.userData.hospitalAddr;
      this.visitData.phone = $h.autoHyphenPhone(this.userData.loginId);
      this.visitData.name = this.userData.name;
      this.visitData.userType = this.userData.userType;
    });
  },
  methods: {
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const RF = this.$refs;

      if (!RF.form.validate()) {
        return;
      }

      this.$refs.refConfirmDialog.open("MR 방문신청 접수하시겠습니까?");
    },
    clickPopupConfirm() {
      const $h = this.$helper;
      const DT = this.visitData;
      DT.endpoint = "mrVisitHistory";
      DT.endpointUser = "user";
      DT.user_id = this.userData.userId;
      DT.phone = this.visitData.phone.replaceAll('-','');
      DT.contents = this.visitData.contents == '기타 문의' ? this.visitData.contentsEtc : this.visitData.contents;

      this.saveDataQuery(DT).then((res) => {
        if (res === undefined) return;

        this.completed = true
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    ...mapActions(["getMeInfo", "saveDataQuery"]),
  },
};
</script>

<style lang="scss">
@media (min-width: 769px) {
  div.mr-visit {
    .bottom-btn {
      padding: 20px calc((100% - 600px) / 2);
      .v-btn__content {
        color:#fff;
        font-weight: 800;
      }
    }
  }
}
.mr-visit {
  position: relative;
  padding-bottom: 150px;

  .page-inner {
    padding: 20px;
    height: calc(100svh - 220px);
    position: relative;

    .v-btn:not(.v-btn--round).v-size--x-large {
      margin-top: 30px;
    }
  }
}
</style>
